module.exports = __webpack_public_path__ + "static/media/type-book.d884def4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/type-book.svg
// module id = 117
// module chunks = 0